// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b2b-filter-select.ant-select .ant-select-selector {
  height: 40px !important;
  padding: 0 12px !important;
  border-radius: 8px !important;
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  display: flex;
  align-items: center;
}

.affiliate-orders-table .ant-input {
  height: 40px;
  border-radius: 8px;
}

.b2b-filter-select.ant-select .ant-select-selection-placeholder,
.b2b-filter-select.ant-select .ant-select-selection-item {
  line-height: 38px !important;
  display: flex;
  align-items: center;
}

.b2b-filter-select.ant-select .ant-select-selection-search-input {
  height: 38px !important;
}

.affiliate-orders-table .ant-table-container {
  overflow-x: auto;
}

.affiliate-orders-table .ant-table-content table {
  min-width: 1360px;
}

.affiliate-orders-table .ant-table-thead > tr > th,
.affiliate-orders-table .ant-table-tbody > tr > td {
  white-space: nowrap;
}

.affiliate-partner-edit {
  padding: 8px;
}
.affiliate-partner-edit .collapse1 {
  margin-bottom: 18px;
}
.affiliate-partner-edit .collapse1 .ant-collapse {
  overflow: hidden;
  border: 1px solid #e1e8f0;
  border-radius: 8px;
  background: #fff;
}
.affiliate-partner-edit .collapse1 .ant-collapse-header {
  min-height: 50px;
  padding: 14px 20px !important;
  color: #172033 !important;
  font-size: 15px;
  font-weight: 600;
  background: #f8fafc;
  align-items: center !important;
}
.affiliate-partner-edit .collapse1 .ant-collapse-content {
  border-top: 1px solid #e8eef4;
}
.affiliate-partner-edit .collapse1 .ant-collapse-content-box {
  padding: 0 !important;
}
.affiliate-partner-edit .collapse1 .collapse1 {
  margin: 0;
}
.affiliate-partner-edit .collapse1 .collapse1 .ant-collapse {
  border-width: 0 0 1px;
  border-radius: 0;
}
.affiliate-partner-edit__form .ant-form-item {
  display: flex;
  align-items: flex-start;
  min-height: 76px;
  margin: 0 !important;
  padding: 16px 24px;
  border-bottom: 1px solid #e8eef4;
}
.affiliate-partner-edit__form .ant-form-item:last-child {
  border-bottom: 0;
}
.affiliate-partner-edit__form .ant-form-item > .ant-row {
  width: 100%;
}
.affiliate-partner-edit__form .ant-form-item .ant-form-item-label {
  flex: 0 0 22% !important;
  padding: 8px 20px 0 0 !important;
  text-align: left !important;
}
.affiliate-partner-edit__form .ant-form-item .ant-form-item-label > label {
  height: auto !important;
  color: #172033 !important;
  font-size: 15px !important;
  font-weight: 600;
  line-height: 22px;
}
.affiliate-partner-edit__form .ant-form-item .ant-form-item-control {
  flex: 1 1 !important;
  max-width: none !important;
  min-width: 0;
}
.affiliate-partner-edit__form .ant-form-item .ant-col-offset-4 {
  margin-left: 0 !important;
}
.affiliate-partner-edit__form .ant-form-item .ant-input,
.affiliate-partner-edit__form .ant-form-item .ant-input-number,
.affiliate-partner-edit__form .ant-form-item .ant-select-selector {
  width: 100% !important;
  min-height: 44px !important;
  border: 1px solid #ccd8e5 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #172033 !important;
  font-size: 15px;
}
.affiliate-partner-edit__form .ant-form-item .ant-input,
.affiliate-partner-edit__form .ant-form-item .ant-input-number-input {
  padding: 10px 14px;
}
.affiliate-partner-edit__form .ant-form-item .ant-select-single .ant-select-selector {
  display: flex;
  align-items: center;
  padding: 0 14px !important;
}
.affiliate-partner-edit__form .ant-form-item .ant-select-selection-placeholder,
.affiliate-partner-edit__form .ant-form-item .ant-input::placeholder {
  color: #7c96b5 !important;
  font-weight: 400;
}
.affiliate-partner-edit__form .ant-form-item .ant-input:hover,
.affiliate-partner-edit__form .ant-form-item .ant-input:focus,
.affiliate-partner-edit__form .ant-form-item .ant-input-focused,
.affiliate-partner-edit__form .ant-form-item .ant-input-number:hover,
.affiliate-partner-edit__form .ant-form-item .ant-input-number-focused,
.affiliate-partner-edit__form .ant-form-item .ant-select-focused .ant-select-selector,
.affiliate-partner-edit__form .ant-form-item .ant-select-selector:hover {
  border-color: #0b63ce !important;
  box-shadow: 0 0 0 2px rgba(11, 99, 206, 0.08) !important;
}
.affiliate-partner-edit__form .ant-form-item .ant-radio-wrapper {
  margin: 6px 20px 6px 0;
  color: #172033;
  font-size: 14px;
}
.affiliate-partner-edit__form .ant-form-item .ant-form-item-extra {
  margin-top: 6px;
  color: #60758d;
  line-height: 1.45;
}
.affiliate-partner-edit__actions {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 18px;
  padding: 14px 0 6px;
}
.affiliate-partner-edit__actions .invert-fill-btn {
  min-width: 112px;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
}

.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e8eef4;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header .ant-typography {
  margin: 0;
  color: #172033;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header .partner-information-card-title {
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: 0;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header .partner-information-referral-domain {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: min(560px, 100%);
  min-width: 0;
  padding: 6px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  flex-wrap: wrap;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header .partner-information-referral-domain__label {
  color: #615c5c;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header .partner-information-referral-domain__value {
  min-width: 0;
  overflow: hidden;
  color: #2563eb;
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header .partner-information-referral-domain .ant-btn {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  padding: 0;
  color: #1d4ed8;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header .ant-btn {
  padding-inline: 8px;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header .invert-fill-btn {
  font-size: 14px;
  padding: 8px 16px;
  height: 36px;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-card-header .invert-fill-btn .button-content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-readonly {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 24px;
  padding: 8px 20px 20px;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-readonly__row {
  min-width: 0;
  padding: 16px 0;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-readonly__label-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-readonly__icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #eff6ff;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-readonly__icon {
  color: #075dc5;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-readonly__label {
  display: block;
  color: #004195;
  font-size: 15px;
  font-weight: 600;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-readonly__value {
  display: block;
  overflow-wrap: anywhere;
  color: #172033;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  padding-left: 42px;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .users-form-grid {
  padding-top: 20px;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .users-form-grid .ant-form-item {
  display: block;
  min-height: 0;
  margin: 0 !important;
  padding: 0;
  border-bottom: 0;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .users-form-grid .ant-form-item .ant-form-item-label,
.affiliate-partner-edit.users-form-layout .partner-information-form-card .users-form-grid .ant-form-item .ant-form-item-control {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .users-form-grid .ant-form-item .ant-form-item-label {
  padding: 0 0 6px !important;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .users-form-grid .ant-form-item .ant-form-item-label > label {
  color: #004195 !important;
  font-size: 14px !important;
  font-weight: 600;
}
.affiliate-partner-edit.users-form-layout .partner-information-form-card .users-form-grid .ant-form-item .ant-input,
.affiliate-partner-edit.users-form-layout .partner-information-form-card .users-form-grid .ant-form-item .ant-input-number,
.affiliate-partner-edit.users-form-layout .partner-information-form-card .users-form-grid .ant-form-item .ant-select-selector {
  min-height: 42px !important;
  border-color: #e2e8f0 !important;
  box-shadow: none !important;
  font-size: 14px;
}

@media (max-width: 768px) {
  .affiliate-partner-edit.users-form-layout .partner-information-form-card .partner-information-readonly {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .affiliate-partner-edit.users-form-layout .partner-information-card-title {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
  .affiliate-partner-edit {
    padding: 0;
  }
  .affiliate-partner-edit .collapse1 .ant-form-item {
    display: block;
    padding: 16px;
  }
  .affiliate-partner-edit .collapse1 .ant-form-item .ant-form-item-label {
    max-width: 100% !important;
    padding: 0 0 8px !important;
  }
  .affiliate-partner-edit__actions {
    flex-wrap: wrap;
    padding-inline: 4px;
  }
  .affiliate-partner-edit__actions .ant-btn {
    flex: 1 1 130px;
  }
  .affiliate-partner-edit__actions .ant-btn-dangerous {
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/B2BAffiliateProgram/index.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,4BAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAIA;EACE,YAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAGI;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AADN;AAII;EACE,gBAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;AAFN;AAKI;EACE,6BAAA;AAHN;AAMI;EACE,qBAAA;AAJN;AAQI;EACE,SAAA;AANN;AAQM;EACE,qBAAA;EACA,gBAAA;AANR;AAYI;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gCAAA;AAVN;AAYM;EACE,gBAAA;AAVR;AAaM;EACE,WAAA;AAXR;AAcM;EACE,wBAAA;EAEA,gCAAA;EACA,2BAAA;AAbR;AAeQ;EACE,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;AAbV;AAiBM;EACE,oBAAA;EACA,0BAAA;EACA,YAAA;AAfR;AAkBM;EACE,yBAAA;AAhBR;AAmBM;;;EAGE,sBAAA;EACA,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;AAjBR;AAoBM;;EAEE,kBAAA;AAlBR;AAqBM;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AAnBR;AAsBM;;EAEE,yBAAA;EACA,gBAAA;AApBR;AAuBM;;;;;;;EAOE,gCAAA;EACA,wDAAA;AArBR;AAwBM;EACE,sBAAA;EACA,cAAA;EACA,eAAA;AAtBR;AAyBM;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAvBR;AA4BE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA1BJ;AA4BI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AA1BN;;AAkCI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AA/BN;AAiCM;EACE,SAAA;EACA,cAAA;AA/BR;AAkCM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAhCR;AAmCM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAjCR;AAmCQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AAjCV;AAoCQ;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlCV;AAqCQ;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AAnCV;AAuCM;EACE,mBAAA;AArCR;AAwCM;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AAtCR;AAwCQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAtCV;AA2CI;EACE,aAAA;EACA,gDAAA;EACA,WAAA;EACA,sBAAA;AAzCN;AA2CM;EACE,YAAA;EACA,eAAA;AAzCR;AA4CM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA1CR;AA6CM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA3CR;AA8CM;EACE,cAAA;AA5CR;AA+CM;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA7CR;AAgDM;EACE,cAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA9CR;AAkDI;EACE,iBAAA;AAhDN;AAkDM;EACE,cAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;AAhDR;AAkDQ;;EAEE,yBAAA;EACA,0BAAA;AAhDV;AAmDQ;EACE,2BAAA;AAjDV;AAmDU;EACE,yBAAA;EACA,0BAAA;EACA,gBAAA;AAjDZ;AAqDQ;;;EAGE,2BAAA;EACA,gCAAA;EACA,2BAAA;EACA,eAAA;AAnDV;;AA0DA;EAEI;IACE,gDAAA;EAxDJ;EA2DE;IACE,uBAAA;IACA,sBAAA;IACA,QAAA;EAzDJ;EA6DA;IACE,UAAA;EA3DF;EA6DE;IACE,cAAA;IACA,aAAA;EA3DJ;EA6DI;IACE,0BAAA;IACA,2BAAA;EA3DN;EA+DE;IACE,eAAA;IACA,mBAAA;EA7DJ;EA+DI;IACE,eAAA;EA7DN;EAgEI;IACE,cAAA;EA9DN;AACF","sourcesContent":[".b2b-filter-select.ant-select .ant-select-selector {\n  height: 40px !important;\n  padding: 0 12px !important;\n  border-radius: 8px !important;\n  background: #f8fafc !important;\n  border: 1px solid #e2e8f0 !important;\n  display: flex;\n  align-items: center;\n}\n\n.affiliate-orders-table .ant-input {\n  height: 40px;\n  border-radius: 8px;\n}\n\n.b2b-filter-select.ant-select .ant-select-selection-placeholder,\n.b2b-filter-select.ant-select .ant-select-selection-item {\n  line-height: 38px !important;\n  display: flex;\n  align-items: center;\n}\n\n.b2b-filter-select.ant-select .ant-select-selection-search-input {\n  height: 38px !important;\n}\n\n.affiliate-orders-table .ant-table-container {\n  overflow-x: auto;\n}\n\n.affiliate-orders-table .ant-table-content table {\n  min-width: 1360px;\n}\n\n.affiliate-orders-table .ant-table-thead>tr>th,\n.affiliate-orders-table .ant-table-tbody>tr>td {\n  white-space: nowrap;\n}\n\n// Scoped version of the CMS form treatment for the partner edit tab.\n// It deliberately does not affect the shared AbstractForm styles.\n.affiliate-partner-edit {\n  padding: 8px;\n\n  .collapse1 {\n    margin-bottom: 18px;\n\n    .ant-collapse {\n      overflow: hidden;\n      border: 1px solid #e1e8f0;\n      border-radius: 8px;\n      background: #fff;\n    }\n\n    .ant-collapse-header {\n      min-height: 50px;\n      padding: 14px 20px !important;\n      color: #172033 !important;\n      font-size: 15px;\n      font-weight: 600;\n      background: #f8fafc;\n      align-items: center !important;\n    }\n\n    .ant-collapse-content {\n      border-top: 1px solid #e8eef4;\n    }\n\n    .ant-collapse-content-box {\n      padding: 0 !important;\n    }\n\n    // Nested customization accordions remain visually subordinate.\n    .collapse1 {\n      margin: 0;\n\n      .ant-collapse {\n        border-width: 0 0 1px;\n        border-radius: 0;\n      }\n    }\n  }\n\n  &__form {\n    .ant-form-item {\n      display: flex;\n      align-items: flex-start;\n      min-height: 76px;\n      margin: 0 !important;\n      padding: 16px 24px;\n      border-bottom: 1px solid #e8eef4;\n\n      &:last-child {\n        border-bottom: 0;\n      }\n\n      >.ant-row {\n        width: 100%;\n      }\n\n      .ant-form-item-label {\n        flex: 0 0 22% !important;\n\n        padding: 8px 20px 0 0 !important;\n        text-align: left !important;\n\n        >label {\n          height: auto !important;\n          color: #172033 !important;\n          font-size: 15px !important;\n          font-weight: 600;\n          line-height: 22px;\n        }\n      }\n\n      .ant-form-item-control {\n        flex: 1 1 0 !important;\n        max-width: none !important;\n        min-width: 0;\n      }\n\n      .ant-col-offset-4 {\n        margin-left: 0 !important;\n      }\n\n      .ant-input,\n      .ant-input-number,\n      .ant-select-selector {\n        width: 100% !important;\n        min-height: 44px !important;\n        border: 1px solid #ccd8e5 !important;\n        border-radius: 6px !important;\n        box-shadow: none !important;\n        color: #172033 !important;\n        font-size: 15px;\n      }\n\n      .ant-input,\n      .ant-input-number-input {\n        padding: 10px 14px;\n      }\n\n      .ant-select-single .ant-select-selector {\n        display: flex;\n        align-items: center;\n        padding: 0 14px !important;\n      }\n\n      .ant-select-selection-placeholder,\n      .ant-input::placeholder {\n        color: #7c96b5 !important;\n        font-weight: 400;\n      }\n\n      .ant-input:hover,\n      .ant-input:focus,\n      .ant-input-focused,\n      .ant-input-number:hover,\n      .ant-input-number-focused,\n      .ant-select-focused .ant-select-selector,\n      .ant-select-selector:hover {\n        border-color: #0b63ce !important;\n        box-shadow: 0 0 0 2px rgba(11, 99, 206, 0.08) !important;\n      }\n\n      .ant-radio-wrapper {\n        margin: 6px 20px 6px 0;\n        color: #172033;\n        font-size: 14px;\n      }\n\n      .ant-form-item-extra {\n        margin-top: 6px;\n        color: #60758d;\n        line-height: 1.45;\n      }\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-top: 18px;\n    padding: 14px 0 6px;\n\n    .invert-fill-btn {\n      min-width: 112px;\n      height: 44px;\n      font-size: 15px;\n      font-weight: 600;\n    }\n  }\n}\n\n// Match the two-column Users / Agent Information form card in the partner edit tab.\n.affiliate-partner-edit.users-form-layout {\n  .partner-information-form-card {\n    .partner-information-card-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 16px 20px;\n      border-bottom: 1px solid #e8eef4;\n\n      .ant-typography {\n        margin: 0;\n        color: #172033;\n      }\n\n      .partner-information-card-title {\n        display: flex;\n        align-items: center;\n        gap: 24px;\n        min-width: 0;\n      }\n\n      .partner-information-referral-domain {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        max-width: min(560px, 100%);\n        min-width: 0;\n        padding: 6px 10px;\n        border: 1px solid #bfdbfe;\n        border-radius: 999px;\n        background: #eff6ff;\n        color: #1d4ed8;\n        flex-wrap: wrap;\n\n        &__label {\n          color: #615c5c;\n          font-size: 11px;\n          font-weight: 700;\n          letter-spacing: 0.04em;\n          text-transform: uppercase;\n          white-space: nowrap;\n        }\n\n        &__value {\n          min-width: 0;\n          overflow: hidden;\n          color: #2563eb;\n          font-size: 13px;\n          font-weight: 600;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        .ant-btn {\n          flex: 0 0 auto;\n          width: 24px;\n          height: 24px;\n          padding: 0;\n          color: #1d4ed8;\n        }\n      }\n\n      .ant-btn {\n        padding-inline: 8px;\n      }\n\n      .invert-fill-btn {\n        font-size: 14px;\n        padding: 8px 16px;\n        height: 36px;\n\n        .button-content {\n          display: inline-flex;\n          align-items: center;\n          gap: 8px;\n        }\n      }\n    }\n\n    .partner-information-readonly {\n      display: grid;\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n      gap: 0 24px;\n      padding: 8px 20px 20px;\n\n      &__row {\n        min-width: 0;\n        padding: 16px 0;\n      }\n\n      &__label-wrap {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 8px;\n      }\n\n      &__icon-box {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 32px;\n        height: 32px;\n        flex-shrink: 0;\n        border-radius: 6px;\n        background: #eff6ff;\n      }\n\n      &__icon {\n        color: #075dc5;\n      }\n\n      &__label {\n        display: block;\n        color: #004195;\n        font-size: 15px;\n        font-weight: 600;\n      }\n\n      &__value {\n        display: block;\n        overflow-wrap: anywhere;\n        color: #172033;\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 1.5;\n        padding-left: 42px;\n      }\n    }\n\n    .users-form-grid {\n      padding-top: 20px;\n\n      .ant-form-item {\n        display: block;\n        min-height: 0;\n        margin: 0 !important;\n        padding: 0;\n        border-bottom: 0;\n\n        .ant-form-item-label,\n        .ant-form-item-control {\n          flex: 0 0 100% !important;\n          max-width: 100% !important;\n        }\n\n        .ant-form-item-label {\n          padding: 0 0 6px !important;\n\n          >label {\n            color: #004195 !important;\n            font-size: 14px !important;\n            font-weight: 600;\n          }\n        }\n\n        .ant-input,\n        .ant-input-number,\n        .ant-select-selector {\n          min-height: 42px !important;\n          border-color: #e2e8f0 !important;\n          box-shadow: none !important;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .affiliate-partner-edit.users-form-layout {\n    .partner-information-form-card .partner-information-readonly {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .partner-information-card-title {\n      align-items: flex-start;\n      flex-direction: column;\n      gap: 4px;\n    }\n  }\n\n  .affiliate-partner-edit {\n    padding: 0;\n\n    .collapse1 .ant-form-item {\n      display: block;\n      padding: 16px;\n\n      .ant-form-item-label {\n        max-width: 100% !important;\n        padding: 0 0 8px !important;\n      }\n    }\n\n    &__actions {\n      flex-wrap: wrap;\n      padding-inline: 4px;\n\n      .ant-btn {\n        flex: 1 1 130px;\n      }\n\n      .ant-btn-dangerous {\n        margin-left: 0;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
